import FigureCategoryList from "../../components/figure/FigureCategoryList";

const FigureCategoriesPage = () => {
    return <FigureCategoryList/>
}

export default FigureCategoriesPage;
